<template>
  <div class="full-page-loading" role="status" aria-live="polite">
    <v-progress-circular indeterminate color="primary" size="40" />
    <span>Loading...</span>
  </div>
</template>

<style scoped>
.full-page-loading {
  display: flex;
  min-height: 100dvh;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  color: var(--text-understated, inherit);
}
</style>
